import { render, staticRenderFns } from "./CourseTasks.vue?vue&type=template&id=189b6b2e&scoped=true"
import script from "./CourseTasks.vue?vue&type=script&lang=js"
export * from "./CourseTasks.vue?vue&type=script&lang=js"
import style0 from "./CourseTasks.vue?vue&type=style&index=0&id=189b6b2e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189b6b2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('189b6b2e')) {
      api.createRecord('189b6b2e', component.options)
    } else {
      api.reload('189b6b2e', component.options)
    }
    module.hot.accept("./CourseTasks.vue?vue&type=template&id=189b6b2e&scoped=true", function () {
      api.rerender('189b6b2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CourseTasks.vue"
export default component.exports